export default __webpack_public_path__ + "static/media/about3.72057b43.jpeg";